import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { mutateAsync } from "redux-query";
import { loginQuery } from "../../actions/queries";
import { minIOPasswordByRegionId, minIOUserByRegionId } from "../../constants/formOptions";
import { statusIsGood } from "../../utils/helpers";
import { useCurrentUser } from "../useCurrentUser";
import { useSelectedRecord } from "../useSelectedRecord";

const UPLOAD_URL = process.env.REACT_APP_UPLOAD_URL || 'http://129.116.70.173:8080/java_minio2/UploadFile'
const TDIS_AUTH_URL_BASE = process.env.REACT_APP_TDIS_AUTH_URL_BASE || 'https://ms2-dev.tacc.utexas.edu/tdis_authentication/api'

const getPowershellScript = (username, password, bucket, minIOUser, minIOPassword) => {
  return (
`###
# This is a powershell script (7.2.0)
# Installation instructions here - https://docs.microsoft.com/en-us/powershell/scripting/install/installing-powershell-on-windows?view=powershell-7.2#installing-the-msi-package
# Download it here - https://github.com/PowerShell/PowerShell/releases
# This script requires you to input the following:
# --your TDIS Upload UserName $stringHeader.Name "username" uses following $stringContent for value
# --your TDIS Upload credentials $stringHeader.Name "credentials" uses following $stringContent for value
# --your TDIS Upload bucket (AWS S3 Context) $stringHeader.Name "bucket" uses following $stringContent for value
# --your filename for your file on the file system in the bucket $stringHeader.Name "filename" uses following $stringContent for value
# --File Path (no trailing slashes (\\) ) this is done with $multipartFile and the $FileStream to stream the large file to the Ingest Endpoint
# --File Path is recursive beneath it - any subfolders will also be parsed
# --Script should be 'Run As Administrator" to ensure that any locks and blocks will not cause issues with the execution
# --Each time the script runs it appends info about the files uploaded to txt file in the execution directory into a file called uploadReport.txt
###
## Incoming Directory as a parameter
$incomngDir=$args[0]
## Url for Token Handoff and Authentication
$apiUri = "${TDIS_AUTH_URL_BASE}/auth/signin"
## Credentials to receive JWT
$data = @{
 username = "${username}"
 password = "${password}"
}
$requestBody = $data | ConvertTo-Json -Compress
[Net.ServicePointManager]::SecurityProtocol = [Net.SecurityProtocolType]::Tls12
$raw_result = Invoke-RestMethod -Method Post -Uri $apiUri -Body $requestBody -ContentType "application/json"
$result_data = $raw_result.accessToken
Write-Host $result_data
$dataTwo = ""
$requestHeaders = @{'x-access-token' = $result_data}
Get-ChildItem -Recurse $incomngDir | Where { ! $_.PSIsContainer } | ForEach-Object  {
$daDir = $_.FullName
$daName = $_.Name
    Write-Host $daName
    Write-Host $daDir
##This holds all of the information about your upload
$multipartContent = [System.Net.Http.MultipartFormDataContent]::new()
$multipartFile = $daDir
$FileStream = [System.IO.FileStream]::new($multipartFile, [System.IO.FileMode]::Open)
$fileHeader = [System.Net.Http.Headers.ContentDispositionHeaderValue]::new("form-data")
$fileHeader.Name = "file"
$fileHeader.FileName = $daName
$fileContent = [System.Net.Http.StreamContent]::new($FileStream)
$fileContent.Headers.ContentDisposition = $fileHeader
$multipartContent.Add($fileContent)
$stringHeader = [System.Net.Http.Headers.ContentDispositionHeaderValue]::new("form-data")
$stringHeader.Name = "username"
$StringContent = [System.Net.Http.StringContent]::new("${minIOUser}")
$StringContent.Headers.ContentDisposition = $stringHeader
$multipartContent.Add($stringContent)
$stringHeader = [System.Net.Http.Headers.ContentDispositionHeaderValue]::new("form-data")
$stringHeader.Name = "credentials"
$StringContent = [System.Net.Http.StringContent]::new("${minIOPassword}")
$StringContent.Headers.ContentDisposition = $stringHeader
$multipartContent.Add($stringContent)
$stringHeader = [System.Net.Http.Headers.ContentDispositionHeaderValue]::new("form-data")
$stringHeader.Name = "bucket"
$StringContent = [System.Net.Http.StringContent]::new("${bucket}")
$StringContent.Headers.ContentDisposition = $stringHeader
$multipartContent.Add($stringContent)
$stringHeader = [System.Net.Http.Headers.ContentDispositionHeaderValue]::new("form-data")
$stringHeader.Name = "filename"
$StringContent = [System.Net.Http.StringContent]::new($daName)
$StringContent.Headers.ContentDisposition = $stringHeader
$multipartContent.Add($stringContent)
$stringHeader = [System.Net.Http.Headers.ContentDispositionHeaderValue]::new("form-data")
$stringHeader.Name = "filepath"
$StringContent = [System.Net.Http.StringContent]::new($multipartFile)
$StringContent.Headers.ContentDisposition = $stringHeader
$multipartContent.Add($stringContent)
$urlShort = "${UPLOAD_URL}"
Invoke-WebRequest -Uri $urlShort -Headers $requestHeaders -Body $multipartContent -Method "POST"
$dateNow =  Get-Date -Format "yyyy_MM_dd_THH_mm_ss"
"\`nUploaded " + $daDir + " to TDIS Data Ingest at " + $dateNow
}`
  )
}

export const usePowershellDownload = () => {
  const dispatch = useDispatch();
  const [selectedRecord] = useSelectedRecord();
  const { username } = useCurrentUser();
  // const password = useSelector(passwordSelector);
  const regionId = (selectedRecord ? selectedRecord.currentMetadata.twdbFloodPlanningRegionID : null) || '01';
  const bucket = `twdb-region-${regionId}`;
  const minIOUser = minIOUserByRegionId[regionId];
  const minIOPassword = minIOPasswordByRegionId[regionId];

  const promptForPassword = () => {
    const passwordInput = prompt("Please re-enter your password", "");
    dispatch(mutateAsync(loginQuery({ username, password: passwordInput }))).then(({ status }) => {
      if (statusIsGood(status)) {
        getFile(passwordInput);
      } else {
        toast.error("Incorrect password, please try again")
      }
    })
  }
  const getFile = (currentPassword) => {
    const exportedFilename = `upload_script.ps1`;
    var blob = new Blob([getPowershellScript(username, currentPassword, bucket, minIOUser, minIOPassword)], { type: 'text/plain;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, exportedFilename);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
  }
  return promptForPassword;
}